export default (theme) => ({
  helpDeskLink: {
    margin: theme.spacing(2),
    fontSize: 12,
  },
});
